import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Linkedin, Facebook, Instagram, X } from 'lucide-react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: Linkedin, url: 'http://www.linkedin.com/in/future-tech-hr-services-22189038a', label: 'LinkedIn', clickable: true },
    { icon: Facebook, url: 'https://www.facebook.com/share/17D8TdYRcu/', label: 'Facebook', clickable: true },
    { icon: X, url: 'https://x.com/services64809', label: 'X', clickable: true },
    { icon: Instagram, url: 'https://www.instagram.com/solutionsfuturetech/?utm_source=qr&igsh=Mmw4N3R0N2VwcXNm#', label: 'Instagram', clickable: true }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <motion.div
            className="footer-section company-info"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h3>Future Tech HR Services</h3>
            <p className="company-description">
              Connecting talent with opportunities since 2013. We specialize in finding, 
              connecting, and building success through integrated tech-based solutions.
            </p>
            <div className="contact-details">
              <div className="contact-item">
                <Phone size={18} />
                <span>+91 8748863377</span>
              </div>
              <div className="contact-item">
                <Phone size={18} />
                <span>+91 7204273201</span>
              </div>
              <div className="contact-item">
                <Mail size={18} />
                <span>hr@futuretechhrservices.com</span>
              </div>
              <div className="contact-item">
                <MapPin size={18} />
                <span>Head Office: Raichur, Karnataka, India</span>
              </div>
              <div className="contact-item">
                <MapPin size={18} />
                <span>Branch Office: Kalaburagi, Karnataka, India</span>
              </div>
            </div>
            <div className="social-links">
              {socialLinks.map((social, index) => (
                social.clickable ? (
                  <motion.a
                    key={social.label}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: index * 0.1 }}
                  >
                    <social.icon size={20} />
                  </motion.a>
                ) : (
                  <motion.div
                    key={social.label}
                    className="social-link social-link-disabled"
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: index * 0.1 }}
                    title={`${social.label} - Coming Soon`}
                  >
                    <social.icon size={20} />
                  </motion.div>
                )
              ))}
            </div>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Future Tech HR Services Private Limited. All rights reserved.</p>
            <div className="company-details">
              <span>CIN: U78100KA2025PTC208816</span>
            </div>
            <div className="developer-credit">
              <p>
                Crafted with care by{' '}
                <a 
                  href="https://www.laharisoftwares.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="developer-link"
                >
                  Lahari Softwares
                </a>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
